module.exports = __webpack_public_path__ + "static/media/personal2.258ad6f1.jpg";